import { render } from "./TalentsComponent.vue?vue&type=template&id=7e793f04"
import script from "./TalentsComponent.vue?vue&type=script&lang=js"
export * from "./TalentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__